// Profile state
import { createMapStore } from '@lib/state/store.js';

export const profileStore = createMapStore({
  user: null,
  subscription: null,
  stats: {
    totalVideos: 0,
    creditsRemaining: 0,
  },
  isLoading: false,
  error: null,
});
